import { takeEvery, take, put, select, fork } from 'redux-saga/effects';
import get from 'lodash/get';
// consts
import { consts as loginConsts } from '../auth/login';
import { consts as loginAzureConsts } from '../auth/login-azure';
import { consts as signupConsts } from '../auth/signup/signup-req';
import { consts as editUserConsts } from '../profiles/edit-user';
import { consts as editPatientConsts } from '../profiles/edit-patient';
import { consts as editProviderConsts } from '../profiles/edit-provider';
import { consts as createPatientConsts } from '../profiles/create-patient';
import { actions as changeLoggedUserActions } from '../profiles/change-profile-req';
import { consts as loggedUserConsts } from './loggedUser';
import { consts as getLoggedUserConsts } from '../profiles/get-logged-user';
import { consts as localeConsts } from '../ui/locale';
import { isLoggedUserSelector, loggedUserIdSelector } from './selectors';
import { showMfaNoticePopup } from '../ui/popup';
import {
  selectRegistrationCompleted,
  selectRequestPasswordUpdate,
} from '../auth/selectors';
import { selectUiPopupVisible } from '../ui/selectors';
import { isSupportedBrowser } from '../../utils/browserChecker';
import { PAPERWORK } from '../../constants/routes';

// actions
const LOGIN = loginConsts.SUCCEED;
const LOGIN_AZURE = loginAzureConsts.SUCCEED;
const SIGNUP = signupConsts.SUCCEED;
const CREATE_PATIENT = createPatientConsts.SUCCEED;
const EDIT_USER = editUserConsts.SUCCEED;
const EDIT_PATIENT = editPatientConsts.SUCCEED;
const EDIT_PROVIDER = editProviderConsts.SUCCEED;

const IS_BROWSER_SUPPORTABLE = isSupportedBrowser();
/*
 * Saga for adding user data to context/loggedUser state
 */
function* addLoggedUserWorker({ payload }) {
  yield put({
    type: loggedUserConsts.ADD,
    payload,
  });
  const user = payload.user || payload;
  const locale = get(user, 'settings.languageSettings', null);

  if (locale) {
    yield put({
      type: localeConsts.SET_LOCALE,
      payload: locale,
    });
  }

  const { pathname } = window.location;
  const uiPopupContentVisible = yield select(selectUiPopupVisible);
  const isRequestPasswordUpdate = yield select(selectRequestPasswordUpdate);
  const isRegistrationCompleted = yield select(selectRegistrationCompleted);
  const showMfaNotice = get(user, 'showMfaNotice', false);
  const mfaEnabled = get(user, 'mfaEnabled', false);

  if (
    IS_BROWSER_SUPPORTABLE &&
    showMfaNotice &&
    !mfaEnabled &&
    isRegistrationCompleted &&
    !isRequestPasswordUpdate &&
    !uiPopupContentVisible &&
    !pathname.includes(PAPERWORK)
  ) {
    yield put(showMfaNoticePopup());
  }
}

export function* addLoggedUserSaga() {
  yield takeEvery([LOGIN, SIGNUP, LOGIN_AZURE], addLoggedUserWorker);
}

export function* fetchLoggedUserSaga() {
  const action = yield take(getLoggedUserConsts.SUCCEED);
  yield fork(addLoggedUserWorker, action);
}

/*
 * Saga for updating user data to context/loggedUser state
 */
function* createLoggedUserWorker(action) {
  yield put({
    type: loggedUserConsts.UPDATE,
    payload: action.payload,
  });
}

export function* createLoggedUserSaga() {
  yield takeEvery([CREATE_PATIENT], createLoggedUserWorker);
}

/*
 * Saga for updating user data to context/loggedUser state
 */
function* updateLoggedUserWorker(action) {
  // review and delete comment
  try {
    const state = yield select();
    const { targetUserId } = state.context.permissions;
    const { id: loggedUserId } = state.context.loggedUser;
    const isLoggedUser = isLoggedUserSelector(state);

    const registerUser = !targetUserId;
    const editLoggedUser = targetUserId && isLoggedUser;

    const payloadId = get(action, 'payload.id');

    if ((registerUser || editLoggedUser) && payloadId === loggedUserId) {
      yield put({
        type: loggedUserConsts.UPDATE,
        payload: action.payload,
      });
    }
  } catch (e) {
    console.error('Error while editing another user', e);
  }
}

export function* updateLoggedUserSaga() {
  yield takeEvery(
    [EDIT_USER, EDIT_PATIENT, EDIT_PROVIDER],
    updateLoggedUserWorker,
  );
}

function* changeLoggedUserDataWorker({ payload }) {
  const loggedUserId = yield select(loggedUserIdSelector);
  const { id } = payload;

  if (id === loggedUserId) {
    yield put({
      type: loggedUserConsts.UPDATE,
      payload,
    });
  }
}

export function* changeLoggedUserDataSaga() {
  yield takeEvery(
    [changeLoggedUserActions.succeed],
    changeLoggedUserDataWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/context/loggedUserSagas.js